import withStyles from "react-jss"

const styles = {
  link: {
    // color: "#1a1a1a",
    color: "#000000",
    textDecoration: "underline",
    transition: "color 0.15s ease-out",
    "&:hover": {
      color: "#057dbc",
    },
    "&:focus": {
      color: "#057dbc",
    },
  },
}

const Link = ({ classes, href, children }) => {
  return (
    <a
      className={classes.link}
      href={href}
      target="_blank"
      rel="noreferrer noopener">
      {children}
    </a>
  )
}

export default withStyles(styles)(Link)
